export interface NewCombo {
  id: number
  name: string
  headline: string
  headlineAccent: string
  includes: string[]
  price: number
  /** Precio tachado. Se omite cuando no hay descuento que mostrar. */
  originalPrice?: number
  image: string
  imageAlt: string
  /** La foto de origen trae un fondo blanco quemado: se muestra sobre una tarjeta clara. */
  imageOnLightCard?: boolean
  freeShipping: boolean
  pain: string
  description: string
  benefits: string[]
  waMessage: string
}

export const newCombos: NewCombo[] = [
  {
    id: 1,
    name: 'Creatine POWER 300g — Promo 2x1',
    headline: 'Promo 2x1',
    headlineAccent: 'Creatine Power',
    includes: ['2 x Creatine Monohydrate POWER 300g'],
    price: 1090,
    image:
      'https://cdn.magicpatterns.com/uploads/hsBQG4Ss6GBW5iTdjBMqdH/Firefly_(1).png',
    imageAlt: 'Creatine Monohydrate POWER 300g de Profit Laboratórios',
    freeShipping: false,
    pain: '¿Llegás a las últimas repeticiones sin fuerza y sentís que te falta ese empujón final? Sin creatina, tus músculos agotan su reserva de energía explosiva en segundos y dejás series —y resultados— sobre la mesa. Y cuando se termina el pote, cortás la suplementación justo cuando empezabas a notar el cambio.',
    description:
      'Llevate dos Creatine Monohydrate POWER 300g de Profit Laboratórios por un precio único. Creatina 100% pura, sin azúcar y sin gluten: el suplemento más estudiado del mundo. Con 600g en total tenés meses de suplementación continua para aumentar tu fuerza, potencia y volumen muscular sin interrupciones — o compartila con tu compañero de entrenamiento.',
    benefits: [
      '2 unidades de 300g — 600g en total',
      'Aumenta la fuerza en cada serie',
      'Favorece la masa muscular',
      'Mejora el rendimiento y la potencia',
      'Acelera la recuperación entre series',
      'Creatina pura y segura — sin azúcar ni gluten',
    ],
    waMessage:
      'Hola! Quiero la Promo 2x1 de Creatine Monohydrate POWER 300g por $1.090 UY. ¿Tienen stock disponible?',
  },
  {
    id: 2,
    name: 'Combo XPro Nutrition — Promo 2x1',
    headline: 'Promo 2x1',
    headlineAccent: 'Combo XPro Nutrition',
    includes: [
      '2 x Muscle Whey Protein 900g',
      '2 x Creatine 100g',
      "2 x BCAA's 100g — sabor frutilla",
    ],
    price: 2090,
    image:
      'https://cdn.magicpatterns.com/uploads/aBQSzCUJgd9rU6Wm9JXbGb/Firefly.png',
    imageAlt:
      "Combo XPro Nutrition: Muscle Whey Protein 900g, Creatine 100g y BCAA's 100g",
    freeShipping: false,
    pain: '¿Querés suplementarte en serio pero comprar proteína, creatina y aminoácidos por separado se te va del presupuesto? Y cuando se terminan, volvés a empezar de cero y perdés la constancia que te da resultados.',
    description:
      'Dos combos completos de XPro Nutrition por un precio único. Cada combo incluye Muscle Whey Protein 900g (blend proteico superior, 18g de proteína por dosis), Creatine 100g de absorción ultra rápida y BCAA 100g en relación 2:1:1 sabor frutilla. Los tres pilares de la suplementación por partida doble: para vos por más tiempo, o para entrenar en pareja.',
    benefits: [
      '2 combos completos — el doble de duración',
      'Muscle Whey Protein 900g — 18g de proteína por dosis',
      'Creatine 100g de absorción ultra rápida',
      "BCAA's 100g en relación 2:1:1",
      'Los tres pilares de la suplementación',
      'Ideal para compartir con tu compañero de entreno',
    ],
    waMessage:
      "Hola! Quiero la Promo 2x1 del Combo XPro Nutrition — Muscle Whey Protein 900g + Creatine 100g + BCAA's 100g por $2.090 UY. ¿Tienen stock disponible?",
  },
]
